// extracted by mini-css-extract-plugin
export default {"componentWrapper":"SubLayoutDashboard_componentWrapper__N5cBY","menuWrapper":"SubLayoutDashboard_menuWrapper__S1iUy"};